import {Construtor} from './construtor';
import { CriterioReincidenciaRotina } from './criterio-reincidencia-rotina';

export class ReincidenciaRotina implements Construtor<ReincidenciaRotina> {

  public idReincidenciaRotina: number;
  public idRotinaCliente: number;
  public idUsuario: number;
  public quantidadeOcorrencias: number;
  public dataInicioReferencia: Date;
  public dataFimReferencia: Date;
  public conteudoEmail: string;
  public mesesAte: number;
  public semanasAte: number;
  public diasAte: number;
  public criterios: CriterioReincidenciaRotina[];

  constructor(object?: any) {
    this.criterios = new Array<CriterioReincidenciaRotina>();

    if (object !== undefined) {

      if (object instanceof ReincidenciaRotina) {
        this.copyObject(object);
      } else {
        this.parseFromJson(object);
      }

      return this.modeloCompleto() ? this : null;
    }

    return this;
  }

  copyObject(rotina: ReincidenciaRotina): void {
    this.idReincidenciaRotina = rotina.idReincidenciaRotina;
    this.idRotinaCliente = rotina.idRotinaCliente;
    this.idUsuario = rotina.idUsuario;
    this.quantidadeOcorrencias = rotina.quantidadeOcorrencias;
    this.dataInicioReferencia = rotina.dataInicioReferencia;
    this.dataFimReferencia = rotina.dataFimReferencia;
    this.conteudoEmail = rotina.conteudoEmail;
    this.mesesAte = rotina.mesesAte;
    this.semanasAte = rotina.semanasAte;
    this.diasAte = rotina.diasAte;
    this.criterios = rotina.criterios;
  }

  parseFromJson(rotina: any): void {
    this.idReincidenciaRotina = rotina.idReincidenciaRotina;
    this.idRotinaCliente = rotina.idRotinaCliente;
    this.idUsuario = rotina.idUsuario;
    this.quantidadeOcorrencias = rotina.quantidadeOcorrencias;
    this.dataInicioReferencia = rotina.dataInicioReferencia;
    this.dataFimReferencia = rotina.dataFimReferencia;
    this.conteudoEmail = rotina.conteudoEmail;
    this.mesesAte = rotina.mesesAte;
    this.semanasAte = rotina.semanasAte;
    this.diasAte = rotina.diasAte;
    this.criterios = rotina.criterios;
  }

  modeloCompleto(): boolean {
    return this.idRotinaCliente !== undefined && this.idUsuario !== undefined;
  }

  getNewInstance(object?: any): ReincidenciaRotina {
    return new ReincidenciaRotina(object);
  }

}



// WEBPACK FOOTER //
// C:/Development/Projects/Sun/Flag/workspace/flagvarejoang4/src/app/comum/modelos/reincidencia-rotina.ts